/**
 * Report data types for sales analysis
 */

import { create } from "zustand";

export interface SaleOutcome {
    saleMade: boolean;
    explanation: string;
}

export interface ConversationFeedback {
    timestamp: string;
    role: "customer" | "seller";
    text: string;
    feedback: string | null;
}

export interface CriticalMoment {
    timestamp: string;
    type: "opportunity_gained" | "opportunity_missed";
    description: string;
    suggestion: string;
}

export interface ReportData {
    overallScore: number;
    shortAnalysis: string;
    saleOutcome: SaleOutcome;
    personaAnalysis: string;
    positives: string[];
    negatives: string[];
    conversationFeedback: ConversationFeedback[];
    criticalMoments: CriticalMoment[];
    detailedAnalysis: string;
}

interface ReportState {
    isLoading: boolean;
    report: ReportData | null;
    showReport: boolean;
    error: string | null;
    setLoading: (loading: boolean) => void;
    setReport: (report: ReportData) => void;
    setShowReport: (show: boolean) => void;
    setError: (error: string | null) => void;
    closeReport: () => void;
}

export const useReportStore = create<ReportState>((set) => ({
    isLoading: false,
    report: null,
    showReport: false,
    error: null,

    setLoading: (loading) => set({ isLoading: loading }),

    setReport: (report) => set({ report, isLoading: false, showReport: true }),

    setShowReport: (show) => set({ showReport: show }),

    setError: (error) => set({ error, isLoading: false }),

    closeReport: () => set({ showReport: false, report: null, error: null }),
}));

